import texts from '../states/homePage'

export default function homePageReducer(state=texts,action){
    const temp = {...state}
 
    
    return temp
}